<template>
  <div class="container">
    <div class="top">
      <div class="years">
        <el-date-picker
          type="year"
          placeholder="选择年份"
          v-model="date1"
          style="width: 100%"
          @input="handleYearChange"
          :format="'yyyy'"
        ></el-date-picker>
      </div>
      <div class="months">
        <el-date-picker
          type="month"
          placeholder="选择月份"
          v-model="date2"
          style="width: 100%"
          :format="'MM'"
          @input="handlemonthChange"
        ></el-date-picker>
      </div>
      <el-button style="width: 70px" type="primary" @click="inquireHandel"
        >查询</el-button
      >
      <router-link to="/send_word/info">
        <el-button type="primary" id="send_btn">添加</el-button>
      </router-link>
    </div>
    <div class="main">
      <el-table :data="tableData" border style="width: 100%" align="center">
        <el-table-column
          fixed
          prop="id"
          label="id"
          id="send_id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="日期"
          align="center"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="bott">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getcalendarlist } from "@/api/coupon";
export default {
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
      date1: "",
      date2: "",
      yeasr: "",
      page: 1,
      months: "",
      tableData: [],
      query: {
        date: this.date1 + this.date2,
        limit: 10,
        page: 1,
      },
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的条数
      totalItems: 0, // 列表总条数
      dataList: [], // 存储列表数据
    };
  },
  created() {
    this.searchData();
  },
  //   watch:{
  //     date2(newvalue){
  //         console.log(newvalue);
  //     }
  //   },
  methods: {
    handlePageChange(currentPage) {
      // 当页码改变时，更新 currentPage 并重新获取数据
      console.log(currentPage);
      this.query.page = currentPage;
      this.searchData();
    },
    handleYearChange(value) {
      if (value === null) {
        this.yeasr = ""; // 清空 year 变量
        console.log(this.years,'未转译');
        return;
      }
      const dateString = value;
      const date = new Date(dateString);
      const year = date.getFullYear();
      this.yeasr = year;
      console.log(this.yeasr,'转译完');
    },
    handlemonthChange(value) {
      if (value === null) {
        this.months = ""; // 清空 year 变量
        console.log(this.months);
        return;
      }
      //  选择月份
      const date = new Date(value);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      this.months = month;
      console.log(this.months);
      //   console.log(this.date2);
    },
    inquireHandel() {
      console.log(this.yeasr + this.months);
      let date = this.yeasr + "-" + this.months;
      this.query.date = date;
      this.searchData();
    },
    handleClick(row) {
      // 详情
      console.log(row);
      //   this.$router.push({ name: 'send_word/info', params: { id } });
      this.$router.push(`/send_word/info?id=${row.id}`);
    },
    // 列表 getcalendarlist
    searchData() {
      getcalendarlist(this.query).then((res) => {
        console.log(res);
        this.tableData = res.data.list;
        this.totalItems = res.data.total;
      });
    },
  },
};
</script>

<style>
.container {
  width: 100%;
  height: auto;
  /* padding: 30px; */
  box-sizing: border-box;
}
.top {
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
}
.years {
  margin-right: 30px;
}
.months {
  margin-right: 30px;
}
#send_btn {
  margin-left: 100px;
  width: 70px;
}
.main {
  margin-top: 100px;
}
.send_id {
  width: 200px;
}
/* .el-table {
  border: 1px solid #ccc; 
}
.el-table th,
.el-table td {
  border-width: 1px; 
  border-style: solid;
  border-color: #ccc;
} */
.bott {
  margin: 20px auto 0;
}
.el-date-picker__header--bordered:nth-child(2) {
  display: none;
}
</style>